var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card shadow-sm" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("h5", { staticClass: "card-title" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("pages.admin.video.index.filter.filter")) +
            "\n        "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c(
            "label",
            {
              staticClass: "font-weight-bolder",
              attrs: { for: "series-select" }
            },
            [_vm._v(_vm._s(_vm.$t("pages.admin.video.index.filter.series")))]
          ),
          _vm._v(" "),
          _c("v-select", {
            attrs: {
              id: "series-select",
              options: _vm.options,
              placeholder: _vm.$t("pages.admin.video.index.filter.series_name")
            },
            on: {
              input: function($event) {
                return _vm.selectedSeries($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-group mt-2" }, [
        _c(
          "label",
          { staticClass: "font-weight-bolder", attrs: { for: "video-title" } },
          [_vm._v(_vm._s(_vm.$t("pages.admin.video.index.filter.video_title")))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.videoTitle,
              expression: "videoTitle"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            id: "video-title",
            placeholder: _vm.$t("pages.admin.video.index.filter.video_title")
          },
          domProps: { value: _vm.videoTitle },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.videoTitle = $event.target.value
              },
              _vm.debounceVideoInput
            ]
          }
        })
      ]),
      _vm._v(" "),
      !_vm.anyFiltersSet
        ? _c("div", { staticClass: "alert alert-secondary border-dark mt-2" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("pages.admin.video.index.filter.none_set")) +
                "\n        "
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }